// @flow
import { SurveysActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    survey: {},
    listaSurveys: [],
    loading: false,
    loadingForm: false,
    error: false,
    formSubmited: false
};

type SurveysAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { survey?: {} | null, listaSurveys?: [] | null, loading?: boolean, +value ?: boolean };

const Surveys = (state: State = INIT_STATE, action: SurveysAction): any => {
    // console.log(action);
    switch (action.type) {
        case SurveysActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case SurveysActionTypes.GET_SURVEY: {
                    return {
                        ...state,
                        survey: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case SurveysActionTypes.LIST_SURVEYS: {
                    return {
                        ...state,
                        listaSurveys: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case SurveysActionTypes.ADD_SURVEY: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case SurveysActionTypes.DUPLICATE_SURVEY: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case SurveysActionTypes.UPDATE_SURVEY: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case SurveysActionTypes.DELETE_SURVEY: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case SurveysActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case SurveysActionTypes.GET_SURVEY: {
                    return {
                        ...state,
                        error: action.payload.error,
                        survey: {},
                        loading: false,
                    };
                }
                case SurveysActionTypes.LIST_SURVEYS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaSurveys: [],
                        loading: false,
                    };
                }
                case SurveysActionTypes.ADD_SURVEY: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case SurveysActionTypes.DUPLICATE_SURVEY: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case SurveysActionTypes.UPDATE_SURVEY: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case SurveysActionTypes.DELETE_SURVEY: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case SurveysActionTypes.GET_SURVEY:
            return { ...state, error: false, loading: true };
        case SurveysActionTypes.LIST_SURVEYS:
            return { ...state, error: false, loading: true };
        case SurveysActionTypes.ADD_SURVEY:
            return { ...state, error: false, loadingForm: true };
        case SurveysActionTypes.DUPLICATE_SURVEY:
            return { ...state, error: false, loadingForm: true };
        case SurveysActionTypes.UPDATE_SURVEY:
            return { ...state, error: false, loadingForm: true };
        case SurveysActionTypes.DELETE_SURVEY:
            return { ...state, error: false, loading: true };
        case SurveysActionTypes.RESET:
            return {
                ...state,
                loading: false,
                loadingForm: false,
                error: false,
                survey: {},
                listaSurveys: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default Surveys;
